import React from 'react'

import { Form, Col, Button, Modal } from '_zari/core'
import { CodigosTransaccionesConstant } from 'constants/index'

import { ZariContext } from '_zari/context'

const TransaccionModal = ({ value, setFieldValue, show, handleClose }) => {
  const [transaccionSeleccionada, setTransaccionSeleccionada] = React.useState('')
  const __zariContext = React.useContext(ZariContext)
  const clickAgregar = React.useCallback(() => {
    if (value.find(x => x === transaccionSeleccionada)) {
      __zariContext.snack('error', 'La transaccion Ingresada ya esta asignada')
    } else {
      let transacciones = value
      transacciones.push(transaccionSeleccionada)
      setFieldValue('transacciones', transacciones)
      handleClose()
    }
  }, [value, transaccionSeleccionada, setFieldValue, __zariContext, handleClose])

  return (
    <Modal show={show} size='md'>
      <Modal.Body>
        <Form.Group>
          <Form.Label text='Transacciones' htmlFor='select-nombre' md={4} />
          <Col md={8}>
            <Form.Select
              name='transacciones-select'
              id='transacciones-select-id'
              value={transaccionSeleccionada}
              onChange={e => setTransaccionSeleccionada(e.target.value)}
            >
              <option value=''>Seleccionar</option>
              {CodigosTransaccionesConstant.__array.map((val, key) => (
                <option key={key} value={CodigosTransaccionesConstant.__dictionary[val].id}>
                  {CodigosTransaccionesConstant.__dictionary[val].nombre}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={handleClose}>
          Cerrar
        </Button>
        <Button color='primary' onClick={clickAgregar}>
          Agregar
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(TransaccionModal)
